// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__JXUbS","plus":"styles_plus__zSKp0","key":"styles_key__urLy9"};